import React, { FunctionComponent } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

import { SmallContainer } from 'app/components/container';
import { Tabs } from 'app/components/tabs';
import { HouseType } from 'app/pages/order/model/house-type';
import {
    selectHasCustomerDebt,
    selectIsExtraUnitNeeded,
    selectIsPurchasingSingleUnit,
    selectReachedStep,
    selectSelectedHouseType,
    selectShoppingCartOrThrow,
} from 'app/pages/order/redux/order-selector';
import { OrderStepService } from 'app/pages/order/services/order-step-service';
import { ProductDetailsTab } from 'app/pages/order/product-details/product-details-tab';
import { largeHouseImageProps, mediumHouseImageProps } from 'app/resources/images';
import { useAppDispatch } from 'app/hooks/thunk-hooks';
import { selectHouseTypeActionCreator } from 'app/pages/order/redux/action-creators/select-house-type-action-creator';

import { ProductDetailsPageTabLabel } from './product-details-tab-label';

export const ProductDetailsPage: FunctionComponent = () => {
    const selectedHouseType = useSelector(selectSelectedHouseType);
    const shoppingCart = useSelector(selectShoppingCartOrThrow);
    const extraUnitIsNeeded = useSelector(selectIsExtraUnitNeeded);
    const customerHasDebt = useSelector(selectHasCustomerDebt);
    const isPurchasingSingleUnit = useSelector(selectIsPurchasingSingleUnit);
    const reachedStep = useSelector(selectReachedStep);
    const dispatch = useAppDispatch();

    const handleHouseTypeChange = (houseType: HouseType) => {
        if (selectedHouseType !== houseType) {
            dispatch(selectHouseTypeActionCreator(houseType));
        }
    };

    if (isPurchasingSingleUnit) {
        return <Navigate to={OrderStepService.getStepPath(reachedStep)} replace={true} />;
    }

    return (
        <SmallContainer>
            <Tabs
                selectedTab={selectedHouseType}
                changeSelectedTab={(houseType) => handleHouseTypeChange(houseType as HouseType)}
            >
                <ProductDetailsTab
                    tabKey={HouseType.MEDIUM_HOUSE}
                    title={
                        <ProductDetailsPageTabLabel image={mediumHouseImageProps} houseType={HouseType.MEDIUM_HOUSE} />
                    }
                    houseType={HouseType.MEDIUM_HOUSE}
                    customerHasDebt={customerHasDebt}
                    extraUnitIsNeeded={extraUnitIsNeeded}
                    shoppingCart={shoppingCart}
                />
                <ProductDetailsTab
                    tabKey={HouseType.LARGE_HOUSE}
                    title={
                        <ProductDetailsPageTabLabel image={largeHouseImageProps} houseType={HouseType.LARGE_HOUSE} />
                    }
                    houseType={HouseType.LARGE_HOUSE}
                    customerHasDebt={customerHasDebt}
                    extraUnitIsNeeded={extraUnitIsNeeded}
                    shoppingCart={shoppingCart}
                />
            </Tabs>
        </SmallContainer>
    );
};
